import { a as parseConfig } from "../chunk-config.mjs";
import { log } from "@dxos/log";
import localforage from "localforage";
//#region src/loaders/browser.ts
var __dxlog_file = "/tmp/claude-0/canvas-svg/packages/sdk/config/src/loaders/browser.ts";
var CONFIG_ENDPOINT = "/.well-known/dx/config";
var SETTINGS_KEY = "org.dxos.settings.config";
var Profile = (_profile = "default") => ({});
var Local = () => {
	return typeof __CONFIG_LOCAL__ !== "undefined" ? __CONFIG_LOCAL__ : {};
};
/**
* Config served by the host at {@link CONFIG_ENDPOINT}, enabled by `__DXOS_CONFIG__.dynamic`.
* Yields an empty config when disabled or when the request fails; throws `InvalidConfigError` when
* the response is served but does not match the schema.
*/
var Dynamics = async () => {
	const { publicUrl = "", dynamic } = __DXOS_CONFIG__;
	if (!dynamic) {
		log("dynamics disabled", void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 36,
			S: void 0
		});
		return {};
	}
	log("fetching config...", { publicUrl }, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file,
		L: 40,
		S: void 0
	});
	const endpoint = `${publicUrl}${CONFIG_ENDPOINT}`;
	let data;
	try {
		const response = await fetch(endpoint);
		if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
		data = await response.json();
	} catch (error) {
		log.warn("Failed to fetch dynamic config.", error, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 51,
			S: void 0
		});
		return {};
	}
	return parseConfig(data, endpoint);
};
var Envs = (_basePath) => {
	return typeof __CONFIG_ENVS__ !== "undefined" ? __CONFIG_ENVS__ : {};
};
var Defaults = (_basePath) => {
	return typeof __CONFIG_DEFAULTS__ !== "undefined" ? __CONFIG_DEFAULTS__ : {};
};
/**
* Settings config from browser storage.
*/
var Storage = async () => {
	try {
		const config = await localforage.getItem(SETTINGS_KEY);
		if (config !== null) return parseConfig(config, SETTINGS_KEY);
	} catch (err) {
		log.warn("Failed to load config", { err }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 78,
			S: void 0
		});
	}
	return {};
};
var Remote = (target, authenticationToken) => {
	if (!target) return {};
	try {
		const url = new URL(target);
		const protocol = url.protocol.slice(0, -1);
		return { runtime: { client: {
			remoteSource: url.origin + (protocol.startsWith("http") ? "/vault.html" : ""),
			remoteSourceAuthenticationToken: authenticationToken
		} } };
	} catch (err) {
		log.catch(err, void 0, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 102,
			S: void 0
		});
		return {};
	}
};
//#endregion
export { Defaults, Dynamics, Envs, Local, Profile, Remote, Storage };

//# sourceMappingURL=browser.mjs.map